import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addBlog } from "../utils/addBlogs";

const BlogCMSForm = () => {
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    blog_image: "",
    blog_image_alt: "",
    book_demo_image: "",
    book_demo_alt: "",
    author_name: "",
    category: "",
    category_url: "",
    metaDescription: "",
    content: "",
    section_name: "",
  });

  // Manage keywords as an array with a temporary input value
  const [keywords, setKeywords] = useState([]);
  const [keywordInput, setKeywordInput] = useState("");

  // State to handle the preview modal
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleContentChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
    }));
  };

  const handleKeywordInputChange = (e) => {
    setKeywordInput(e.target.value);
  };

  // When user presses Enter or comma, add the keyword to the list
  const handleKeywordKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const trimmed = keywordInput.trim();
      if (trimmed && !keywords.includes(trimmed)) {
        setKeywords([...keywords, trimmed]);
      }
      setKeywordInput("");
    }
  };

  const removeKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const blogData = { ...formData, keywords };

    try {
      const response = await addBlog(blogData);
      console.log("Blog added successfully:", response);
      // Display toast based on API response
      if (response.status === 1) {
        toast.success(response.message);
      } else {
        toast.error(response.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error adding blog:", error);
      toast.error("Error adding blog");
    }

    // Clear form fields after submission
    setFormData({
      title: "",
      slug: "",
      blog_image: "",
      blog_image_alt: "",
      book_demo_image: "",
      book_demo_alt: "",
      author_name: "",
      category: "",
      category_url: "",
      metaDescription: "",
      content: "",
      section_name: "",
    });
    setKeywords([]);
    setKeywordInput("");
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="max-h-[calc(100vh-315px)] overflow-auto lg:px-8 px-5 pb-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-x-14 md:gap-y-8">
            {/* Title */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">Title</label>
              <input
                required
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter blog title"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Slug */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">Slug</label>
              <input
                required
                type="text"
                name="slug"
                value={formData.slug}
                onChange={handleChange}
                placeholder="Enter slug"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Blog Image */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Blog Image URL
              </label>
              <input
                required
                type="text"
                name="blog_image"
                value={formData.blog_image}
                onChange={handleChange}
                placeholder="Enter blog image URL"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Blog Image Alt */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Blog Image Alt
              </label>
              <input
                type="text"
                required
                name="blog_image_alt"
                value={formData.blog_image_alt}
                onChange={handleChange}
                placeholder="Enter blog image alt text"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Book Demo Image */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Book Demo Image URL
              </label>
              <input
                required
                type="text"
                name="book_demo_image"
                value={formData.book_demo_image}
                onChange={handleChange}
                placeholder="Enter book demo image URL"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Book Demo Alt */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Book Demo Alt
              </label>
              <input
                type="text"
                required
                name="book_demo_alt"
                value={formData.book_demo_alt}
                onChange={handleChange}
                placeholder="Enter book demo alt text"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Author Name */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Author Name
              </label>
              <input
                type="text"
                name="author_name"
                required
                value={formData.author_name}
                onChange={handleChange}
                placeholder="Enter author name"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Category */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Category
              </label>
              <input
                type="text"
                required
                name="category"
                value={formData.category}
                onChange={handleChange}
                placeholder="Enter category"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Category URL */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Category URL
              </label>
              <input
                type="text"
                name="category_url"
                required
                value={formData.category_url}
                onChange={handleChange}
                placeholder="Enter category URL"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
            {/* Keywords */}
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Keywords
              </label>
              <input
                type="text"
                value={keywordInput}
                onChange={handleKeywordInputChange}
                onKeyDown={handleKeywordKeyDown}
                placeholder="Type a keyword and press Enter or comma"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
              <div className="mt-2 flex flex-wrap gap-2">
                {keywords.map((tag, index) => (
                  <span
                    key={index}
                    className="bg-blue-100 text-xs text-blue-700 px-2 py-1 rounded flex items-center"
                  >
                    {tag}
                    <button
                      type="button"
                      onClick={() => removeKeyword(index)}
                      className="ml-1 text-red-500"
                    >
                      &times;
                    </button>
                  </span>
                ))}
              </div>
            </div>
            {/* Meta Description */}
            <div className="md:col-span-2">
              <label className="block text-gray-700 mb-1 text-sm">
                Meta Description
              </label>
              <textarea
                name="metaDescription"
                value={formData.metaDescription}
                onChange={handleChange}
                placeholder="Enter meta description"
                rows="3"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              ></textarea>
            </div>

            {/* Content - Rich Quill */}
            <div className="md:col-span-2">
              <label className="block text-gray-700 mb-1 text-sm">
                Content
              </label>
              <ReactQuill
                className="admin-quill-editor"
                theme="snow"
                value={formData.content}
                onChange={handleContentChange}
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1 text-sm">
                Section Name
              </label>
              <input
                type="text"
                name="section_name"
                required
                value={formData.section_name}
                onChange={handleChange}
                placeholder="Enter Section Name"
                className="w-full border rounded-lg px-3 py-2 border-[#D1DFFC] text-sm"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end items-center lg:px-8 px-5 py-4 border-t">
          <button
            type="button"
            onClick={() => setShowPreviewModal(true)}
            className="bg-gray-800 text-white px-6 py-2 rounded-lg mr-4"
          >
            Preview
          </button>
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-lg"
          >
            Submit
          </button>
        </div>
      </form>
      <ToastContainer />
      {/* Preview Modal */}
      {showPreviewModal && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-white md:p-8 p-5 rounded-lg shadow-lg w-full max-w-5xl overflow-auto max-h-[90vh]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Blog Preview</h2>
              <div>
                <button
                  onClick={() => setShowPreviewModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <img
                    alt="close-icon"
                    className="w-5"
                    src="https://content.qeeb.in/coltec/close-icon.svg"
                  />
                </button>
              </div>
            </div>
            <div>
              <div>
                <h1 className="md:text-[30px] text-[22px] leading-8 font-semibold mb-2.5 max-w-2xl">
                  {formData.title}
                </h1>
              </div>
              <div className="flex items-center">
                <p className="font-medium text-sm mr-3">
                  <span className="text-gray-900">{formData.author_name}</span>
                </p>
                <div>
                  <div className="flex justify-start items-center ml-3">
                    <div>
                      <img
                        alt="Category"
                        src="https://content.qeeb.in/coltec/category-icon.svg"
                        className="h-5"
                      />
                    </div>
                    <div
                      to={formData.category_url}
                      className="bg-white border border-[#242424] ml-3 text-[#000] hover:text-[#242424] py-1 px-3 rounded-full text-sm"
                    >
                      {formData.category}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-12">
                {formData.blog_image && (
                  <img
                    src={formData.blog_image}
                    alt={formData.blog_image_alt || "Blog Image"}
                    className="rounded-lg w-full mb-6"
                  />
                )}
              </div>
              <div>
                <p className="font-normal text-base">{formData.metaDescription}</p>
              </div>
              <div
                className="prose-html mt-5"
                dangerouslySetInnerHTML={{ __html: formData.content }}
              ></div>
              <div>
                {formData.book_demo_image && (
                  <img
                    src={formData.book_demo_image}
                    alt={formData.book_demo_alt || "Book Demo"}
                    className="mt-2 rounded-md"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BlogCMSForm;
